import React from "react"
// import "./ArticleHeader.scss"

class ArticleHeader extends React.Component {

  render() {
    const {modifier} = this.props,
          {title} = this.props,
          {subtitle} = this.props,
          {author} = this.props,
          {authorPrefix} = this.props

    const classes = (modifier ? `article__heading article__heading--${modifier}` : "article__heading")

    return (
      <div className={classes}>
        <div className="cols">
          <div className="col m12">
            <h2>{title}</h2>
            {subtitle && (
              <p className="article__subtitle">{subtitle}</p>
            )}
            {author && (
              <p className="article__author">
                <span>{authorPrefix ? authorPrefix : `Written by`} {author}</span>
                <span>{authorPrefix ? authorPrefix : `Written by`} {author}</span>
              </p>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default ArticleHeader